<div
    class="elastic-list"
    #elasticList
    [class.fluid]="allowFluidResize"
    [class.fill-width]="!showMoreButton"
>
    <ul
        #visibleLinks
        class="visible-links"
    >
        <ng-container
            *ngFor="let opp of metrics; let i = index; trackBy: track_identify"
        >
            <li class="metric-links">
                <metric-button
                    metricBtn
                    [opportunity]="opp"
                    (clicked)="onClick($event)"
                ></metric-button>
            </li>
        </ng-container>
    </ul>

    <ul
        #hiddenLinks
        class="hidden-links"
        [class.hidden]="!showHiddenButtons"
        documentBlurTrigger
        [triggerFlag]="showHiddenButtons"
        (documentBlurred)="toggleHiddenButtons($event)"
    ></ul>

    <!-- <div [ngClass] = "{'all-hidden-buttons-container': allHiddenButtons, 'show-hidden-buttons-container': !allHiddenButtons}"> -->
    <div class="show-hidden-buttons-container">
        <button
            class="show-hidden-buttons"
            #showBtn
            [class.hidden]="!showMoreButton"
            [attr.count]="breaks.length"
            (click)="toggleHiddenButtons()"
        >
            ...
        </button>
    </div>
</div>
